import * as dialog from 'plugins/dialog';

import BaseModal from '@/legacy/modals/BaseModal';
import * as paymentService from '@/legacy/services/company/payment';

declareModules({
  'modals/styled/paymentTransactionError.html': () =>
    import('@/legacy/modals/styled/paymentTransactionError.html'),
});

class ViewModelParams {
  public title: string;

  public body: string;

  public transactionError: string;
}

class StyledModal extends BaseModal {
  view = 'modals/styled/paymentTransactionError';

  public static ViewModelParams: typeof ViewModelParams = ViewModelParams;

  public params: ViewModelParams;

  public transactionErrorDescription: string;

  public transactionErrorTitle: string;

  constructor(params: ViewModelParams) {
    super();
    this.params = params;

    this.transactionErrorTitle = paymentService.Instance.getTransactionErrorTitle(
      params.transactionError,
      false
    );
    this.transactionErrorDescription = paymentService.Instance.getTransactionErrorDescription(
      params.transactionError,
      false
    );
  }

  public close(): void {
    dialog.close(this);
  }

  public continueModal(): void {
    dialog.close(this, true);
  }

  public static show(params: ViewModelParams): JQueryPromise<any> {
    return dialog.show(new StyledModal(params));
  }
}

export default StyledModal;
